import React, { useState } from 'react';
import { postAnulacionReversionOrdenApi, postSolicitudAnulacionOrdenApi } from "../../../api/axios";
import ModalItem from "../../General/Modal";
import { toast } from '../../../utilities/appToast';
import { hasMetodoPagoPermitido, idEstadosOrden } from "../../../helper/ordenHelper";
import PropTypes from 'prop-types';

const BTN = Object.freeze({ CON_DEVOL: 1, SIN_DEVOL: 2, RECHAZO: 3 });
/** EnumTipoEntidad: Decidir=8, MercadoPagoBilletera=14, GiftCard=19 — misma lógica de anulación que Decidir */
const esAnulacionMismaLogicaQueDecidir = (idTipoEntidad) =>
  [8, 14, 19].includes(Number(idTipoEntidad));
const METODOS_PERMITIDOS = Object.freeze([
  'TARJETA DE CRÉDITO',
  'TARJETA DÉBITO',
  'CONTADO A TRAVÉS DE COBROEXPRESS O DEPÓSITO Y/O TRANSFERENCIA BANCARIA',
  'MERCADOPAGO BILLETERA'
]);

export default function AnulacionReversion({
  idOrden,
  idSeller,
  motivosRechazo = [],
  motivoAnulacionSeller,
  goToOrdenes,
  orden,
  setHabilitarInputs,
  setHabilitarInputsVte,
  isCategory = false,
  isAdminMod = false,
  motivosSolicitudAnulacion = [],
  idMotivoAnulacion = "",
  setIdMotivoAnulacion,
}) {

  const [motivoRechazo, setMotivoRechazo] = useState("");
  const [isFetching, setIsFetching] = useState(false);

  const enviarSolicitudAnulacion = (request, continuarConReversion = false) => {
    setIsFetching(true);
    return postSolicitudAnulacionOrdenApi(request)
      .then(() => {
        toast.success("Anulación enviada correctamente");
        if (continuarConReversion) {
          return postAnulacionReversionOrdenApi(request).then(() => {
            toast.success("Estado de orden actualizado");
            goToOrdenes();
          });
        }
      })
      .catch(err => {
        const errs = err?.response?.data?.errores;
        if (Array.isArray(errs) && errs.length) errs.forEach(e => toast.error(e));
        else toast.error("No se pudo enviar la solicitud o actualizar el estado");
      })
      .finally(() => setIsFetching(false));
  };

  const idMotivoResuelto = () =>
    Number(
      motivoAnulacionSeller?.idMotivo ??
        orden?.motivoAnulacion?.idMotivo ??
        orden?.motivoAnulacion?.id ??
        0
    );

  const isValidRechazo = (buttonId) => {
    if (buttonId === BTN.RECHAZO) {
      if (!motivoRechazo) {
        toast.warn("Seleccione un motivo de rechazo");
        return false;
      }
    } else if (buttonId === BTN.CON_DEVOL || buttonId === BTN.SIN_DEVOL) {
      if (!idMotivoResuelto()) {
        toast.warn("Seleccione un motivo de anulación");
        return false;
      }
    }
    return true;
  };

  const postAnulacion = (buttonId) => {
    const cupones = orden?.pago?.cupones ?? [];
    const tieneCupones = cupones.length > 0;
    const metodoPermitido = hasMetodoPagoPermitido(cupones, METODOS_PERMITIDOS);

    if (
      buttonId === BTN.CON_DEVOL &&
      orden?.pago?.cupones?.some(c => !esAnulacionMismaLogicaQueDecidir(c.idTipoEntidad))
    ) {
      const idMotivo = Number(motivoAnulacionSeller?.idMotivo || 0)
      if (!idMotivo) {
        toast.warn("La solicitud de anulación no tiene motivo");
        return;
      }
      if (metodoPermitido) {
        setHabilitarInputs(true);
        return;
      }
      if (!metodoPermitido && tieneCupones) {
        const req = { idVenta: idOrden, idSeller, idMotivoAnulacion: 1, solicitarAnulacion: true };
        return enviarSolicitudAnulacion(req, true);
      }
      if (!tieneCupones) {
        setHabilitarInputsVte(true);
        return;
      }
    } else if (!tieneCupones && buttonId !== BTN.SIN_DEVOL) {
        setHabilitarInputsVte(true);
        return;
      }

    if (buttonId === BTN.SIN_DEVOL || (
      buttonId === BTN.CON_DEVOL &&
      orden?.pago?.cupones?.some(c => esAnulacionMismaLogicaQueDecidir(c.idTipoEntidad))
    )) {
      const idMotivo = Number(motivoAnulacionSeller?.idMotivo) || Number(orden.motivoAnulacion.idMotivo);
      if (!idMotivo && orden?.motivoAnulacion?.idMotivo === 0) {
          toast.warn("La solicitud de anulación no tiene motivo");
          return;
      }

      const requestAnulacion = {
        idVenta: orden.idOrden,
        idSeller: idSeller,
        idMotivoAnulacion: idMotivo,
        solicitarAnulacion: true
      };

      const requestMin = {
        idVenta: orden.idOrden,
        devolucionDinero: buttonId === BTN.CON_DEVOL,
        //devolucionDinero: false,
        rechazado: false,
        idSeller: idSeller,
        idMotivoAnula: idMotivo,
      };

      setIsFetching(true);
      if (orden?.motivoAnulacion?.idMotivo !== 0) {
        // Solo ejecuta esto si el motivo es distinto de 0
        postAnulacionReversionOrdenApi(requestMin)
          .then(() => {
            toast.success("Solicitud de anulación enviada");
            goToOrdenes();
          })
          .catch(err => {
            const errs = err?.response?.data?.errores;
            if (Array.isArray(errs) && errs.length) errs.forEach(e => toast.error(e));
            else toast.error("No se pudo enviar la solicitud");
          })
          .finally(() => setIsFetching(false));
      } else {
        // Si el motivo es 0, sigue el flujo anterior
        postSolicitudAnulacionOrdenApi(requestAnulacion)
          .then(res => {
            toast.success("Solicitud de anulación enviada");
            return postAnulacionReversionOrdenApi(requestMin)
              .then(() => {
                  toast.success("Solicitud de anulación enviada");
                goToOrdenes();
              });
          })
          .catch(err => {
            const errs = err?.response?.data?.errores;
            if (Array.isArray(errs) && errs.length) errs.forEach(e => toast.error(e));
            else toast.error("No se pudo enviar la solicitud");
          })
          .finally(() => setIsFetching(false));
      }
    }

    if (buttonId === BTN.RECHAZO) {
      if (!motivoRechazo) {
        toast.warn("Seleccione un motivo de rechazo");
        return;
      }
      const reqRechazo = {
        idVenta: idOrden,
        idSeller,
        idMotivoAnula: 1,
        devolucionDinero: false,
        rechazado: true,
      };

      setIsFetching(true);
      return postAnulacionReversionOrdenApi(reqRechazo)
        .then(() => {
          toast.success("Rechazo de anulación enviado");
          goToOrdenes();
        })
        .catch(err => {
          const errs = err?.response?.data?.errores;
          if (Array.isArray(errs) && errs.length) errs.forEach(e => toast.error(e));
          else toast.error("No se pudo rechazar la anulación");
        })
        .finally(() => setIsFetching(false));
    }
  };

  const existeAnulado = orden?.estado?.some(e => e.idEstado === 5);
  /** Megatone (category): solicitud pendiente y motivo del seller — aprobar/rechazar anulación */
  const enSolicitudAnulacion =
    orden?.estado?.[0]?.idEstado === idEstadosOrden.solicitarAnulacion;
  const idMotivoSeller = Number(
    orden?.motivoAnulacion?.idMotivo ?? orden?.motivoAnulacion?.id ?? 0
  );
  const mostrarRechazoAnulacion =
    isCategory && enSolicitudAnulacion && idMotivoSeller !== 0;

  const mostrarSelectorMotivoAnulacion =
    (isCategory || isAdminMod) &&
    motivosSolicitudAnulacion?.length > 0 &&
    !(orden?.anulacionMegatone?.anulado || existeAnulado);

  const handleMotivoAnulacion = (e) => {
    if (setIdMotivoAnulacion) {
      setIdMotivoAnulacion(e.target.value);
    }
  };

  return (
    <div className="row mb-3">
      <div className="col-12">
        {!(orden?.anulacionMegatone?.anulado || existeAnulado) && (
          <div className="d-flex align-items-end flex-wrap gap-3">
            {mostrarSelectorMotivoAnulacion && (
              <div
                className="flex-shrink-0 border-end border-secondary border-opacity-25 pe-3"
                style={{ minWidth: "220px", maxWidth: "min(100%, 300px)" }}
              >
                <label htmlFor="motivoAnulacionAnulacionReversion" className="form-label small text-secondary mb-1">Motivo anulación</label>
                <select
                  id="motivoAnulacionAnulacionReversion"
                  className="form-control form-control-sm"
                  value={idMotivoAnulacion !== "" && idMotivoAnulacion !== undefined
                    ? idMotivoAnulacion
                    : (orden?.motivoAnulacion?.idMotivo ?? orden?.motivoAnulacion?.id ?? "")}
                  onChange={handleMotivoAnulacion}
                  disabled={isFetching}
                >
                  <option value="">Seleccione motivo</option>
                  {motivosSolicitudAnulacion.map((motivo) => (
                    <option key={motivo.id} value={motivo.id}>
                      {motivo.descripcion}
                    </option>
                  ))}
                </select>
              </div>
            )}
            {[
              { id: BTN.CON_DEVOL, label: "Anular con devolución" },
              { id: BTN.SIN_DEVOL, label: "Anular sin devolución" },
            ].map((button) => (
              <ModalItem
                key={button.id}
                disabled={isFetching}
                text={`¿Desea ${button.label.toLowerCase()}?`}
                onDelete={() => postAnulacion(button.id)}
                validationHandler={() => isValidRechazo(button.id)}
                btnStyle="btn btn-sm background-rojo-megatone me-2"
                btnText={button.label}
              />
            ))}

            {mostrarRechazoAnulacion && (
              <>
                <ModalItem
                  key={BTN.RECHAZO}
                  disabled={isFetching}
                  text="¿Desea rechazar la anulación?"
                  onDelete={() => postAnulacion(BTN.RECHAZO)}
                  validationHandler={() => isValidRechazo(BTN.RECHAZO)}
                  btnStyle="btn btn-sm background-rojo-megatone me-2"
                  btnText="Rechazar anulación"
                />

                <div style={{ minWidth: 220 }}>
                  <label htmlFor="motivoRechazoAnulacionReversion" className="me-2 mb-0">Motivo de rechazo</label>
                  <select
                    id="motivoRechazoAnulacionReversion"
                    className="form-control"
                    value={motivoRechazo}
                    onChange={(e) => setMotivoRechazo(e.target.value)}
                  >
                    <option value=""></option>
                    {motivosRechazo?.map((motivo, index) => (
                      <option key={motivo.id} value={motivo.id}>
                        {motivo.descripcion}
                      </option>
                    ))}
                  </select>
                </div>
              </>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
AnulacionReversion.propTypes = {
    idOrden: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    idSeller: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    idMotivoAnulacion: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    motivosRechazo: PropTypes.array,
    motivoAnulacionSeller: PropTypes.shape({
        idMotivo: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
    isCategory: PropTypes.bool,
    isAdminMod: PropTypes.bool,
    goToOrdenes: PropTypes.func,
    orden: PropTypes.shape({
        pago: PropTypes.shape({
            cupones: PropTypes.array,
        }),
        motivoAnulacion: PropTypes.shape({
            idMotivo: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        }),
        idOrden: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        estado: PropTypes.array,
        anulacionMegatone: PropTypes.shape({
            anulado: PropTypes.bool,
        }),
    }),
    motivosSolicitudAnulacion: PropTypes.array,
    setHabilitarInputs: PropTypes.func,
    setHabilitarInputsVte: PropTypes.func,
    setIdMotivoAnulacion: PropTypes.func,
}